import { z } from 'zod'

export const invoiceCreateSchema = z.object({
  client_id: z.string().min(1, 'Client ID is required'),
  amount: z.number().positive('Amount must be positive'),
  currency: z.enum(['GBP', 'USD']).optional(),
  due_date: z.string().min(1, 'Due date is required'),
  service_period: z.string().optional(),
  discount_label: z.string().optional(),
  discount_amount: z.number().min(0).optional(),
  stripe_payment_link: z.string().url().optional(),
})

export const invoiceUpdateSchema = z.object({
  status: z.enum(['unpaid', 'paid', 'overdue']).optional(),
  paid_date: z.string().datetime().optional(),
  late_fee: z.number().min(0).optional(),
  stripe_payment_link: z.string().url().optional(),
})
